<button
	class="header-btn themes-trigger"
	[ngClass]="buttonClass()"
	[title]="title()"
	(click)="onThemeToggle()"
>
	@if (themeService.isDarkMode()) {
		<i class="bi bi-brightness-high"></i>
		@if (showLabel()) {
			<span class="vb-lxp-theme-label">{{ lightLabel() }}</span>
		}
	} @else {
		<i class="bi bi-moon"></i>
		@if (showLabel()) {
			<span class="vb-lxp-theme-label">{{ darkLabel() }}</span>
		}
	}
</button>
